//angular imports
import { 
  ChangeDetectionStrategy, 
  Component, 
  input, 
  OnDestroy
} from "@angular/core";

//local imports
import { 
  CloseDialogMessage, 
  CommandModel, 
  Messenger 
} from "@app/shared";

import {
  CreateProjectRequest,
  ProjectDetails,
  ProjectHttpService,
  ProgramModel,
  ProjectCreationInitializedMessage
} from "@app/catalog";

import {
  ProjectAlreadyExistsFault,
  ProjectAlreadyExistsMessage,
} from "@app/catalog-common";

import { 
  ToastLevel,
  ToastMessage
} from "@app/components";

@Component({
  selector: "add-project-form",
  templateUrl: "./add-project-form.component.html",
  styleUrl: "./add-project-form.component.scss",
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class AddProjectFormComponent implements OnDestroy {
  public details = ProjectDetails.empty();

  public programs = input.required<ProgramModel[]>();

  public cancelCommand = new CommandModel({
    executeAction: () => {
      this.messenger.send(new CloseDialogMessage());
      return Promise.resolve();
    },
  });

  public submitCommand = new CommandModel({
    executeAction: () => this.save(),
    isValid: this.details.isValid,
  });

  constructor(
    private projectHttpService: ProjectHttpService,
    private messenger: Messenger,
  ) {}

  private save = async () => {
    let request = new CreateProjectRequest();
    request.programId = this.details.program.value();
    request.name = this.details.name.value();
    request.description = this.details.description.value();
    request.cap = this.details.capNumber.value();
    request.spa = this.details.spaFile();

    let createResult = this.projectHttpService.create(request);

    try {
      await createResult.response;
      this.messenger.send(new CloseDialogMessage());
      this.messenger.send(
          ToastMessage.create(
            new ProjectCreationInitializedMessage(request.name),
            ToastLevel.Success,
          ),
        );
    } catch (error) {
      if (error instanceof ProjectAlreadyExistsFault) {
        this.messenger.send(
          ToastMessage.create(
            new ProjectAlreadyExistsMessage(error.name),
            ToastLevel.Warning,
          ),
        );
      }
    }
  };

  ngOnDestroy(): void {
    this.messenger.unsubscribeByOwner(this);
  }
}
